const STORAGE_PREFIX = 'ov_session_';

const getStorageKey = (name) => `${STORAGE_PREFIX}${name}`;

const normalizeUserData = (value) => {
  if (!value || typeof value !== 'object') return value;

  const selectedTenantId = String(value.selectedTenantId || value.tenantId || '').trim();
  return {
    ...value,
    tenantId: selectedTenantId,
    selectedTenantId,
  };
};

const readLegacyCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');

  for (let index = 0; index < cookies.length; index += 1) {
    let cookie = cookies[index];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);

    if (cookie.indexOf(nameEQ) === 0) {
      const raw = cookie.substring(nameEQ.length);
      try {
        const parsed = JSON.parse(raw);
        return name === 'userData' ? normalizeUserData(parsed) : parsed;
      } catch (error) {
        return raw;
      }
    }
  }

  return null;
};

const readStoredValue = (name) => {
  try {
    const raw = localStorage.getItem(getStorageKey(name));
    if (!raw) return readLegacyCookie(name);

    const parsed = JSON.parse(raw);
    if (parsed?.expiresAt && Date.now() > parsed.expiresAt) {
      localStorage.removeItem(getStorageKey(name));
      return readLegacyCookie(name);
    }

    const value = parsed?.value ?? null;
    return name === 'userData' ? normalizeUserData(value) : value;
  } catch (error) {
    console.warn(`Unable to read stored session value for ${name}:`, error);
    return readLegacyCookie(name);
  }
};

const writeStoredValue = (name, value, expiresAt) => {
  try {
    localStorage.setItem(
      getStorageKey(name),
      JSON.stringify({ value, expiresAt })
    );
  } catch (error) {
    console.warn(`Unable to persist stored session value for ${name}:`, error);
  }
};

// Kept as compatibility wrappers for the existing codebase.
export const setCookie = (name, value, days = 7) => {
  const expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
  writeStoredValue(name, value, expiresAt);
};

export const getCookie = (name) => readStoredValue(name);

export const removeCookie = (name) => {
  try {
    localStorage.removeItem(getStorageKey(name));
  } catch (error) {
    console.warn(`Unable to clear stored session value for ${name}:`, error);
  }

  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Strict`;
};

export const clearAllCookies = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(STORAGE_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    console.warn('Unable to clear stored session values:', error);
  }

  const cookies = document.cookie.split(';');
  for (let index = 0; index < cookies.length; index += 1) {
    const cookie = cookies[index];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    if (name) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Strict`;
    }
  }
};
